import { useEffect, useRef } from 'react'

export const useEffectOnce = (effect: () => void | (() => void)) => {
  const executed = useRef(false)
  const cleanup = useRef<(() => void) | void>()

  useEffect(() => {
    if (!executed.current) {
      cleanup.current = effect()
      executed.current = true
    }

    return () => {
      if (cleanup.current && typeof cleanup.current === 'function') {
        cleanup.current()
      }
    }
  }, [])
}
